<template>
  <el-collapse v-model="daysOfService.filtersOpen">
    <el-collapse-item :title="$t('common.search')" name="days-of-service-search-section" id="days-of-service-search-section">
      <el-form
        id="days-of-service-search-section-form"
        :model="searchForm"
        ref="searchForm"
        label-position="right"
        size="mini"
        class="search-section-form"
        inline
      >
        <el-row :gutter="10">
          <el-col :span="8">
            <el-form-item :label="$t('daysOfService.consignee')">
              <autocomplete
                :model.sync="searchForm.consigneeAccountId"
                labelFieldLastWithDash="number"
                popperAppendToBody
                :url="consigneeAutocompleteUrl"
                :shipperAccountId="user.accountId"
                :selectAction="handleSearch"
                :enterKeyAction="handleSearch"
                :clearAction="handleSearch"
                labelField="name"
                valueField="id"
                id="searchForm-consignee"
              />
            </el-form-item>
          </el-col>
          <el-col :span="8">
             <el-form-item :label="$t('daysOfService.state')">
               <state-select v-model="searchForm.stateId" @change="handleSearch" :includeOptionAll="true" />
             </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item :label="$t('daysOfService.city')">
              <autocomplete
                :model.sync="searchForm.city"
                popperAppendToBody
                :url="cityUrl"
                :selectAction="handleSearch"
                :enterKeyAction="handleSearch"
                :clearAction="handleSearch"
                labelField="name"
                valueField="id"
              />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-col :span="8">
              <el-form-item :label="$t('daysOfService.dayOfWeek')">
                <el-select
                  v-model="daysOfWeekSelected"
                  multiple
                  collapse-tags
                  @change="handleSearch"
                >
                  <el-option
                    v-for="item in daysOfWeek"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :md="8" :sm="12" :xs="24">
                <el-form-item :label="$t('daysOfService.dateFrom')" >
                    <el-date-picker
                    v-model="searchForm.dayOfServiceFromStr"
                    style="width: 100%"
                    format="MM/dd/yyyy"
                    value-format="yyyy-MM-dd"
                    :picker-options="datePickerOptions"
                    type="date"
                    @change="handleSearch"
                    id="form-date-from">
                    </el-date-picker>
                </el-form-item>
            </el-col>
        </el-row>
      </el-form>
    </el-collapse-item>
  </el-collapse>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import StateSelect from '@/components/StateSelect';
import Autocomplete from '@/components/Autocomplete';
import { DOS_SEARCH } from '@/store/actions';

export default {
  name: 'SearchFilters',
  components: { Autocomplete, StateSelect },
  computed: {
    ...mapGetters(['daysOfService', 'user']),
    cityUrl() {
      return apiConstants.END_POINTS.ROUTING.CITIES;
    },
    consigneeAutocompleteUrl() {
      return apiConstants.END_POINTS.ACCOUNTS.CONSIGNEE_BY_SHIPPER;
    },
    daysOfWeek() {
      return constants.DAY_OF_SERVICE.DAYS_OF_WEEK;
    }
  },
  data() {
    return {
      searchForm: {
        consigneeAccountId: null,
        dayOfServiceFromStr: moment().format(constants.DATES.DEFAULT_BACKEND_FORMAT),
        city: null,
        stateId: null,
        view: null
      },
      daysOfWeekSelected: [],
      activeCollapsibleName: ['days-of-service-search-section'],
      datePickerOptions: {
        disabledDate(time) {
          const target = moment(time.getTime());
          return target.isBefore(Date.now(), 'day')
            || (target.day() !== constants.SUNDAY_NUMBER_DAY && !target.isSame(Date.now(), 'day'));
        }
      }
    };
  },
  methods: {
    handleSearch() {
      this.searchForm.view = this.$route.path.replace(/^\//, '');
      const daysOfWeekToSend = {};
      this.searchForm.view = this.$route.path.replace(/^\//, '');
      for (const dow of this.daysOfWeek) {
        daysOfWeekToSend[dow.value] = this.daysOfWeekSelected.some(dowSelected => dow.value === dowSelected);
      }

      this.$store.dispatch(DOS_SEARCH, { ...this.searchForm, ...daysOfWeekToSend });
    }
  }
};
</script>
